import styled from '@emotion/styled';
import { CONTENT_MAX_WIDTH } from 'components/Layout/PageContentWidth';
import { BOTTOM_SECTION_HEIGHT, SIDEBAR_GAP, SIDEBAR_WIDTH } from './constants';
import {
  HEADER_HEIGHT,
  HEADER_SCROLL_PLAY,
  TOOLBAR_HEIGHT,
} from 'components/Tables/Big';
import { borderRadii, layers } from 'app/spacing';
import TableScrollContainer from '__components/Tables/ScrollContainerV2';
import css from '@emotion/css';

export const StyledTableWithSidebar = styled.div`
  display: flex;
  max-width: ${CONTENT_MAX_WIDTH};
  width: 100%;
  margin: 0 auto;
`;

export const StyledDragList = styled.div`
  width: ${SIDEBAR_GAP}px;
  flex-shrink: 0;
  height: 100%;
  padding-top: ${HEADER_HEIGHT};
`;

export const StyledSidebar = styled.div`
  position: relative;
  width: ${SIDEBAR_WIDTH}px;
  flex-shrink: 0;
`;

export const StyledHeader = styled.div<{ scrolled: boolean }>`
  height: ${HEADER_HEIGHT};
  position: sticky;
  top: calc(${TOOLBAR_HEIGHT} - ${HEADER_SCROLL_PLAY});
  z-index: ${layers.content(0, 1)};
  transition: box-shadow 0.5s ease-in-out;
  background-color: var(--color-background-white);
  padding: 0 20px;
  display: flex;
  gap: 8px;
  align-items: center;
  border-bottom: 1px solid
    ${({ scrolled }) =>
      !scrolled ? 'var(--color-border-medium-light)' : 'transparent'};
  transition: border 0.5s ease-in-out;
  border-top-left-radius: ${borderRadii.standard};
  border-top-right-radius: ${borderRadii.standard};
`;

export const StyledFoldersScrollWrapper = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const StyledFolders = styled.div<{
  navBarHeight: number;
  scrolledTop: boolean;
  scrolledBottom: boolean;
  windowTop: number;
}>`
  position: sticky;
  top: calc(${TOOLBAR_HEIGHT} + ${HEADER_HEIGHT} - ${HEADER_SCROLL_PLAY});
  ${({ navBarHeight, windowTop }) => {
    const scrollPlay =
      parseInt(TOOLBAR_HEIGHT, 10) +
      parseInt(HEADER_HEIGHT, 10) +
      BOTTOM_SECTION_HEIGHT +
      Math.max(-parseInt(HEADER_SCROLL_PLAY, 10), navBarHeight - windowTop);

    return css`
      height: calc(100vh - ${scrollPlay}px);
      transition: height 0.3s ease-in-out;
    `;
  }}
  &::before, &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 8px;
    height: 50px;
    pointer-events: none;
    transition: opacity 0.3s ease-in-out;
    z-index: 1;
  }
  &:before {
    top: 0;
    background: linear-gradient(to bottom, white, transparent);
  }
  &:after {
    bottom: 0;
    background: linear-gradient(to top, white, transparent);
  }
  ${({ scrolledTop, scrolledBottom }) => css`
    &::before {
      opacity: ${scrolledTop ? 0 : 1};
    }
    &::after {
      opacity: ${scrolledBottom ? 0 : 1};
    }
  `}

  background-color: var(--color-background-white);
  overflow: hidden;
  border-bottom-left-radius: ${borderRadii.standard};
  border-bottom-right-radius: ${borderRadii.standard};
`;

export const StyledMenuWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 40px;
  width: 80px;
  background: linear-gradient(to right, transparent, white);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  pointer-events: none;
  & > div {
    height: 100%;
    display: flex;
    align-items: center;
    pointer-events: auto;
  }
`;

export const StyledScrollContainer = styled(TableScrollContainer)`
  height: 100%;
  & .BodyForSync {
    flex-direction: column;
  }
`;
